import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Gauge } from "lucide-react";

export function ProductImage({ product, version = 0, className = "", testid }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    let active = true;
    setSrc(null);
    if (!product?.has_image) return;
    api.get(`/inst/products/${product.id}/image`, { responseType: "blob" })
      .then(({ data }) => { if (active) { url = URL.createObjectURL(data); setSrc(url); } })
      .catch(() => {});
    return () => { active = false; if (url) URL.revokeObjectURL(url); };
  }, [product?.id, product?.has_image, version]);
  return (
    <div data-testid={testid} className={`bg-zinc-100 border border-zinc-200 flex items-center justify-center overflow-hidden ${className}`}>
      {src ? <img src={src} alt={product?.name} className="w-full h-full object-contain" /> : <Gauge className="h-12 w-12 text-zinc-300" />}
    </div>
  );
}

export const STATUS_STYLE = {
  "Draft": "border-zinc-300 text-zinc-500",
  "Quote Requested": "border-[#D4AF37] text-[#B8860B] bg-[#D4AF37]/10",
  "In Review": "border-[#0F172A] text-[#0F172A]",
  "Quoted": "border-[#10B981] text-[#10B981] bg-[#10B981]/10",
  "Closed": "border-zinc-300 text-zinc-400 bg-zinc-50",
};

export function StatusPill({ status, testid }) {
  return <span data-testid={testid} className={`text-[10px] uppercase tracking-wide px-2 py-0.5 border whitespace-nowrap ${STATUS_STYLE[status] || STATUS_STYLE.Draft}`}>{status}</span>;
}
